@if (loadingService.loading$ | async) {
  <div class="loading-overlay">
    <div class="spinner"></div>
    <p>Bitte warten...</p>
  </div>
}